export default __webpack_public_path__ + "static/media/thai-ingredients2.511bc4b3.jpeg";